export default __webpack_public_path__ + "701e84a032f716d429049adaa0e5950f.svg";